module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-chrome"
  }, [(_vm.isLoadingCurrentUser) ? _c('loading-indicator') : _c('div', [(_vm.isUnauthorize) ? _c('page403') : _c('div', {
    staticClass: "page-content container"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_c('img', {
    staticClass: "margin-right-10",
    attrs: {
      "src": "/static/images/byteark-logo-blue.png",
      "title": "ByteArk",
      "height": "60"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-t-20"
  }, [_c('p', {
    staticClass: "font-size-12 m-b-5"
  }, [_vm._v("บริษัท ไบต์อาร์ค จำกัด")]), _vm._v(" "), _c('p', {
    staticClass: "font-size-12 m-b-5"
  }, [_vm._v("เลขที่ 1 อาคารพร้อมพันธ์ 2 ชั้น 6 ห้อง 610")]), _vm._v(" "), _c('p', {
    staticClass: "font-size-12 m-b-5"
  }, [_vm._v("ซอยลาดพร้าว 3 ถนนลาดพร้าว แขวงจอมพล")]), _vm._v(" "), _c('p', {
    staticClass: "font-size-12 m-b-5"
  }, [_vm._v("เขตจตุจักร กรุงเทพมหานคร 10900")]), _vm._v(" "), _c('p', {
    staticClass: "font-size-12 m-b-5"
  }, [_vm._v("เบอร์โทรศัพท์ 02-512-2826 โทรสาร 02-512-2827")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-xs-right"
  }, [_c('h3', {
    staticClass: "m-t-20 m-b-0"
  }, [_vm._v(_vm._s(_vm.$t("statement.labels.orderNumber")) + ": " + _vm._s(_vm.statement.order_number))]), _vm._v(" "), _c('p', {
    staticClass: "font-size-18"
  }, [_vm._v(_vm._s(_vm.$t("clientUsageHistory.labels.dateIssued")) + " : " + _vm._s(_vm.dateIssued))]), _vm._v(" "), _c('p', {
    staticClass: "font-size-16"
  }, [_vm._v(_vm._s(_vm.$t("clientUsageHistory.labels.team")) + ": " + _vm._s(_vm.team ? _vm.team.name : ''))]), _vm._v(" "), (_vm.team ? _vm.team.reseller_id != 0 : false) ? _c('p', {
    staticClass: "font-size-16"
  }, [_vm._v(" Reseller : " + _vm._s(_vm.team.reseller.name))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "page-invoice-table table-responsive m-t-60"
  }, [_c('table', {
    staticClass: "table table-hover text-right"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("statement.labels.description")))]), _vm._v(" "), _c('th', {
    staticClass: "text-xs-right"
  }, [_vm._v(_vm._s(_vm.$t("statement.labels.amount")))])])]), _vm._v(" "), _c('tbody', [(_vm.statement) ? _c('tr', [_c('td', {
    staticClass: "text-xs-left"
  }, [_vm._v(_vm._s(_vm.statement.description))]), _vm._v(" "), _c('td', {
    staticClass: "text-xs-right"
  }, [_vm._v(_vm._s(_vm.statement.human_amount) + " " + _vm._s(_vm.$t("billing.currencies.thb")))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right"
  }, [(!_vm.isPrinting) ? _c('button', {
    staticClass: "btn btn-animate btn-animate-side btn-default btn-outline",
    attrs: {
      "type": "button",
      "onclick": "javascript:window.print(); "
    }
  }, [_c('span', [_c('i', {
    staticClass: "icon md-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("action.print")))])]) : _vm._e()]), _vm._v(" "), (_vm.billingInformation) ? _c('div', {
    staticClass: "m-t-40"
  }, [_c('h4', [_vm._v(_vm._s(_vm.billingInformation.first_name) + " " + _vm._s(_vm.billingInformation.last_name))]), _vm._v(" "), _c('div', {
    staticClass: "m-b-5 m-t-10"
  }, [(_vm.team && _vm.team.is_reseller) ? _c('p', [_c('span', {
    staticClass: "p-r-10"
  }, [_vm._v(_vm._s(_vm.billingInformation.company_name))]), _vm._v(" " + _vm._s(_vm.$t("billing.information.labels.taxID")) + " : " + _vm._s(_vm.billingInformation.tax_id))]) : _vm._e(), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "address1"
  }, [_vm._v(_vm._s(_vm.billingInformation.address1))]), _vm._v(" "), _c('span', {
    staticClass: "address2"
  }, [_vm._v(_vm._s(_vm.billingInformation.address2))]), _vm._v(" "), _c('span', {
    staticClass: "city"
  }, [_vm._v(_vm._s(_vm.billingInformation.city))]), _vm._v(" "), _c('span', {
    staticClass: "state"
  }, [_vm._v(_vm._s(_vm.billingInformation.state))]), _vm._v(" "), _c('span', {
    staticClass: "postal-code"
  }, [_vm._v(_vm._s(_vm.billingInformation.zipcode))]), _vm._v(" "), _c('span', {
    staticClass: "country"
  }, [_vm._v(_vm._s(_vm.billingInformation.country))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("billing.information.labels.billingContactPhone")) + " : " + _vm._s(_vm.billingInformation.contact_phone))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("billing.information.labels.billingEmail")) + " : " + _vm._s(_vm.billingInformation.contact_email))])])]) : _vm._e()])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1dae418d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/billings/pages/PageOrderNumberReport.vue
// module id = 511
// module chunks = 1